// extracted by mini-css-extract-plugin
module.exports = {"rootDesktop":"SearchLoadingMessage-module__rootDesktop___EZqgl","rootMobile":"SearchLoadingMessage-module__rootMobile___Vi6wX","text":"SearchLoadingMessage-module__text___9MG+1"};